import { CardCvcElement } from '@stripe/react-stripe-js';
import type { StripeCardCvcElementChangeEvent } from '@stripe/stripe-js';
import { createCardField } from './utils';

export const CardCvc = createCardField<StripeCardCvcElementChangeEvent>({
  ElementComponent: CardCvcElement,
  elementKind: 'cardCvc',
  label: 'CVC',
  wrapperClassName: 'gap-sm w-full',
});
